import { ReactNode } from 'react';

const FilterCardHeader = ({
  gridTemplateColumns,
  children,
}: {
  gridTemplateColumns: string;
  children: ReactNode;
}) => {
  return (
    <div
      className="filter-header filter-card-header"
      style={{
        gridTemplateColumns,
      }}
    >
      {children}
    </div>
  );
};

export default FilterCardHeader;
